export default __webpack_public_path__ + "static/media/chevron_up.30aa545a.svg";